import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/clients.json";

export const useClients = ({ featured = null } = {}) => {
  let items = useSourceFlowCollection(data);

  if (typeof featured === "boolean") {
    items = items.filter((i) => i.featured === featured);
  }

  return items;
};

export default useClients;
